{
  "modules": {
    "inventory": {
      "title": "Inventory Reports",
      "subtitle": "Stock, valuation, expiry, and traceability reports computed directly from the stock ledger."
    },
    "procurement": {
      "title": "Procurement Reports",
      "subtitle": "Purchase order activity across every supplier and warehouse."
    },
    "inboundQuality": {
      "title": "Inbound & Quality Reports",
      "subtitle": "Goods receipt and QC activity across every supplier and warehouse."
    },
    "outbound": {
      "title": "Outbound Reports",
      "subtitle": "Material request and customer dispatch activity across every warehouse."
    },
    "production": {
      "title": "Production Reports",
      "subtitle": "Production order activity — planned vs. produced quantity."
    },
    "adjustments": {
      "title": "Adjustments Reports",
      "subtitle": "Stock adjustment and inter-warehouse transfer activity."
    },
    "approvals": {
      "title": "Approvals Reports",
      "subtitle": "Approval instances still awaiting a decision, across every transaction type."
    },
    "clientSummary": {
      "title": "3PL Client Summary",
      "subtitle": "Stock, activity, and billing rolled up per Client — only relevant once Third-Party Logistics is enabled."
    },
    "jobWork": {
      "title": "Job Work Reports",
      "subtitle": "Subcontracting activity — what is out at each vendor, what has come back, and what is overdue."
    },
    "weightProduction": {
      "title": "Weigh & Label Reports",
      "subtitle": "Weighing plan progress, unconfirmed weighings pending job completion, and the full capture log."
    },
    "traceability": {
      "title": "Traceability Report",
      "subtitle": "Trace any batch — its full ledger history, or the complete supplier-to-customer genealogy."
    }
  },
  "clientSummary": {
    "tabs": {
      "clientStock": "Stock by Client",
      "clientActivity": "Activity by Client",
      "clientBilling": "Billing by Client"
    },
    "materialCount": "Distinct Materials",
    "stockChartTitle": "On-Hand Quantity by Client",
    "grnCount": "GRN Count",
    "acceptedQty": "Accepted Qty",
    "dispatchCount": "Dispatch Order Count",
    "issuedQty": "Issued Qty",
    "activityChartTitle": "Inbound vs. Outbound Document Count by Client",
    "invoiceCount": "Invoice Count",
    "totalInvoiced": "Total Invoiced",
    "paidAmount": "Paid",
    "unpaidAmount": "Unpaid",
    "billingChartTitle": "Total Invoiced by Client"
  },
  "currentStock": {
    "title": "Current Stock",
    "subtitle": "On-hand, allocated, and available quantity per material and warehouse."
  },
  "stockLedger": {
    "title": "Stock Ledger",
    "subtitle": "Transaction-level movement history — every posting that changed stock, in or out."
  },
  "valuation": {
    "title": "Inventory Valuation",
    "subtitle": "Stock value per material, using a quantity-weighted average of receipt unit prices."
  },
  "lowStock": {
    "title": "Low Stock / Reorder",
    "subtitle": "Active materials whose on-hand quantity has fallen to or below their reorder level."
  },
  "nearExpiry": {
    "title": "Near Expiry",
    "subtitle": "Batches expiring within the next 30 days that still carry on-hand stock."
  },
  "abcAnalysis": {
    "title": "ABC Analysis",
    "subtitle": "Materials classified A/B/C by their share of total stock value."
  },
  "purchaseOrderRegister": {
    "title": "Purchase Order Register",
    "subtitle": "Every purchase order line — ordered, received, and pending quantity per line."
  },
  "grnRegister": {
    "title": "GRN Register",
    "subtitle": "Every goods receipt note line — received, accepted, and rejected quantity, with QC status."
  },
  "materialRequestRegister": {
    "title": "Material Request Register",
    "subtitle": "Every material request line raised for the shop floor, with its current status."
  },
  "dispatchOrderRegister": {
    "title": "Dispatch Order Register",
    "subtitle": "Every customer dispatch order line — requested, issued, and pending quantity."
  },
  "productionOrderRegister": {
    "title": "Production Order Register",
    "subtitle": "Every production order — planned vs. produced quantity, by status."
  },
  "stockAdjustmentRegister": {
    "title": "Stock Adjustment Register",
    "subtitle": "Every stock adjustment line — reason, current vs. adjusted quantity, and variance."
  },
  "stockTransferRegister": {
    "title": "Stock Transfer Register",
    "subtitle": "Every stock transfer line between warehouses."
  },
  "pendingApprovalsAging": {
    "title": "Pending Approvals Aging",
    "subtitle": "Every approval instance still awaiting a decision, with hours pending against its SLA."
  },
  "stockAgingReport": {
    "title": "Stock Aging",
    "subtitle": "On-hand stock by material/batch/location, with age computed from its earliest receipt posting."
  },
  "batchTraceability": {
    "title": "Batch Traceability",
    "subtitle": "Pick a batch to see its full movement history from receipt through to consumption or dispatch.",
    "selectBatch": "Batch",
    "batchNo": "Batch No",
    "currentOnHand": "Current On Hand"
  },
  "purchaseRequestRegister": {
    "title": "Purchase Request Register",
    "subtitle": "Every purchase request line raised for procurement, with its current status."
  },
  "supplierPerformance": {
    "title": "Supplier Performance",
    "subtitle": "On-time delivery and rejection rate per supplier, across every purchase order."
  },
  "gateEntryTurnaround": {
    "title": "Gate Entry / Vehicle Turnaround",
    "subtitle": "Every gate entry — time in the yard, from entry to exit."
  },
  "qcAnalysis": {
    "title": "QC Pass/Reject Analysis",
    "subtitle": "Every QC task raised against a GRN line, with its outcome."
  },
  "putawayTat": {
    "title": "Putaway Pending / TAT",
    "subtitle": "Every putaway task — pending queue age, or turnaround time once completed."
  },
  "pickListPerformance": {
    "title": "Pick List Performance",
    "subtitle": "Every pick list — requested vs. picked quantity, and who it's assigned to."
  },
  "packingLoadingRegister": {
    "title": "Packing & Loading Register",
    "subtitle": "Every package — its packing task, carrier, and loading status once dispatched."
  },
  "customerDispatchSummary": {
    "title": "Customer-wise Dispatch Summary",
    "subtitle": "Dispatch order activity aggregated per customer."
  },
  "productionYield": {
    "title": "Production Yield / Rejection",
    "subtitle": "Produced, accepted, and rejected quantity per production order, with yield %."
  },
  "materialConsumption": {
    "title": "Material Consumption vs BOM",
    "subtitle": "Required (BOM-scaled) vs. actual issued quantity, per production order component."
  },
  "productionReceiptRegister": {
    "title": "Production Receipt Register",
    "subtitle": "Every production receipt line — produced, accepted, and rejected quantity, with batch."
  },
  "cycleCountVariance": {
    "title": "Cycle Count Variance / Accuracy",
    "subtitle": "System vs. counted quantity per cycle count line, with variance and accuracy %."
  },
  "returnNoteRegister": {
    "title": "Return Note Register",
    "subtitle": "Every customer or supplier return line, with reason."
  },
  "approvalTurnaround": {
    "title": "Approval Turnaround",
    "subtitle": "Time from raise to final decision, for every Approved/Rejected approval instance."
  },
  "filters": {
    "warehouse": "Warehouse",
    "material": "Material",
    "all": "All"
  },
  "columns": {
    "materialCode": "Code",
    "materialName": "Material",
    "warehouse": "Warehouse",
    "client": "Client",
    "onHand": "On Hand",
    "allocated": "Allocated",
    "available": "Available",
    "uom": "UOM",
    "date": "Date",
    "location": "Location",
    "batch": "Batch",
    "type": "Type",
    "in": "In",
    "out": "Out",
    "balance": "Balance",
    "category": "Category",
    "avgPrice": "Avg Unit Price",
    "value": "Stock Value",
    "reorderLevel": "Reorder Level",
    "safetyStock": "Safety Stock",
    "expiryDate": "Expiry Date",
    "mfgDate": "Mfg Date",
    "daysToExpiry": "Days to Expiry",
    "abcClass": "ABC Class",
    "materialCount": "Materials",
    "percentOfTotal": "% of Total Value",
    "number": "Number",
    "supplier": "Supplier",
    "customer": "Customer",
    "status": "Status",
    "orderDate": "Order Date",
    "expectedDate": "Expected Date",
    "orderedQty": "Ordered Qty",
    "unitPrice": "Unit Price",
    "receivedQty": "Received Qty",
    "pendingQty": "Pending Qty",
    "poNumber": "PO Number",
    "acceptedQty": "Accepted Qty",
    "rejectedQty": "Rejected Qty",
    "qcStatus": "QC Status",
    "requestedBy": "Requested By",
    "requestedQty": "Requested Qty",
    "issuedQty": "Issued Qty",
    "plannedQty": "Planned Qty",
    "producedQty": "Produced Qty",
    "reason": "Reason",
    "currentQty": "Current Qty",
    "adjustedQty": "Adjusted Qty",
    "variance": "Variance",
    "fromWarehouse": "From Warehouse",
    "toWarehouse": "To Warehouse",
    "quantity": "Qty",
    "transactionType": "Transaction Type",
    "currentLevel": "Current Level",
    "totalValue": "Total Value",
    "raisedDate": "Raised",
    "hoursPending": "Hours Pending",
    "slaHours": "SLA (Hrs)",
    "overdue": "Overdue",
    "withinSla": "Within SLA",
    "firstReceivedDate": "First Received",
    "ageDays": "Age (Days)",
    "remarks": "Remarks",
    "rejectionRate": "Rejection Rate",
    "onTimeDelivery": "On-Time Delivery",
    "vehicleNo": "Vehicle No",
    "entryTime": "Entry Time",
    "exitTime": "Exit Time",
    "turnaroundMinutes": "Turnaround (Min)",
    "grnNumber": "GRN Number",
    "sampleSize": "Sample Size",
    "aqlLevel": "AQL Level",
    "inspector": "Inspector",
    "suggestedLocation": "Suggested Location",
    "confirmedLocation": "Confirmed Location",
    "tatHours": "TAT (Hrs)",
    "materialRequest": "Material Request",
    "assignedTo": "Assigned To",
    "pickedQty": "Picked Qty",
    "lines": "Lines",
    "packageNo": "Package No",
    "packingTask": "Packing Task",
    "pickList": "Pick List",
    "carrier": "Carrier",
    "weight": "Weight",
    "packingStatus": "Packing Status",
    "loadingTask": "Loading Task",
    "loadingStatus": "Loading Status",
    "loadedDate": "Loaded Date",
    "totalOrders": "Total Orders",
    "openOrders": "Open Orders",
    "completedOrders": "Completed Orders",
    "producedMaterial": "Produced Material",
    "requiredQty": "Required Qty",
    "variancePercent": "Variance %",
    "yieldPercent": "Yield %",
    "systemQty": "System Qty",
    "countedQty": "Counted Qty",
    "accuracyPercent": "Accuracy %",
    "returnType": "Return Type",
    "party": "Party",
    "decidedDate": "Decided Date",
    "decidedBy": "Decided By",
    "turnaroundHours": "Turnaround (Hrs)",
    "source": "Source",
    "vendor": "Vendor",
    "outputMaterial": "Output Material",
    "expectedReturn": "Expected Return",
    "sentQty": "Sent",
    "stillToSend": "Still to Send",
    "stillAtVendor": "Still at Vendor",
    "expectedQty": "Expected",
    "age": "Age",
    "days": "{{days}} d",
    "overdueDays": "{{days}} d overdue",
    "jobWorkOrder": "Job Work Order",
    "outwardDc": "Outward DC",
    "vendorDc": "Vendor DC",
    "qty": "Qty",
    "batchNo": "Batch No.",
    "zone": "Zone",
    "locationType": "Type",
    "stockStatus": "Stock Status",
    "stage": "Stage",
    "document": "Document",
    "detail": "Detail",
    "sourceMode": "Source",
    "planBasis": "Plan Basis",
    "barcode": "Barcode",
    "actualWeight": "Actual Weight",
    "captureMode": "Capture Mode",
    "operator": "Operator",
    "dateTime": "Date & Time"
  },
  "jobWorkOrderRegister": {
    "title": "Job Work Order Register",
    "subtitle": "Every job work order raised, by vendor and output material."
  },
  "jobWorkPendingAtVendor": {
    "title": "Pending at Vendor",
    "subtitle": "Sent vs. returned per order, with ageing — the register for chasing overdue subcontract work."
  },
  "jobWorkIssueRegister": {
    "title": "Job Work Issue Register",
    "subtitle": "Every material line sent out to a job work vendor."
  },
  "jobWorkReceiptRegister": {
    "title": "Job Work Receipt Register",
    "subtitle": "Every material line received back, with its accept/reject split and QC status."
  },
  "weightProductionPlanRegister": {
    "title": "Plan Register",
    "subtitle": "Every weighing plan, by material and source mode, with planned vs. produced quantity."
  },
  "weightProductionPendingJobCompletion": {
    "title": "Pending Job Completion",
    "subtitle": "Weighings captured but not yet stock-posted, with ageing — the register for chasing unconfirmed capture."
  },
  "weightProductionEntryRegister": {
    "title": "Weighing Register",
    "subtitle": "The full capture log — every weighing, regardless of plan origin or posting state."
  },
  "locationWiseStock": {
    "title": "Location-wise Stock",
    "subtitle": "Current stock broken out by warehouse, zone and rack/bin — what is actually in each place, not just each material."
  },
  "traceability": {
    "title": "Full Traceability",
    "subtitle": "Trace a barcode or batch number end to end — from supplier through production/job work to the customer, or back the other way.",
    "hint": "Scan or type a barcode, or type a batch number, then pick a direction. Forward shows where this material ended up (supplier → customer); Backward shows what went into it (customer → supplier).",
    "query": "Barcode or Batch No.",
    "queryHelper": "Press Enter or click Trace.",
    "forward": "Forward (Supplier → Customer)",
    "backward": "Backward (Customer → Supplier)",
    "trace": "Trace",
    "ambiguous": "That batch number belongs to more than one material in this system. Pick the one you meant:",
    "notFound": "Nothing matches \"{{query}}\".",
    "resolved": "Tracing {{material}}, batch {{batch}} — resolved from {{via}}."
  }
}
